import UnfilledButton from "@/components/common/unfilled-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import Link from "next/link";
import { LicenseName } from "@/data/license.data";
import FilledButton from "@/components/common/filled-button";

interface IncreaseLimitsButtonProps {
  filled: boolean;
  onClick?: () => void;
}

const IncreaseLimitsButton = ({
  filled,
  onClick,
}: IncreaseLimitsButtonProps) => {
  return (
    <Link href={"/pricing"}>
      {filled ? (
        <FilledButton text={"Upgrade"} onClick={onClick} />
      ) : (
        <UnfilledButton
          text={"UPGRADE"}
          borderColor={"#F9A825"}
          onClick={onClick}
        />
      )}
    </Link>
  );
};

export default IncreaseLimitsButton;
